
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexC4wtTfMSq5wSxagLwVnpzz9qSv14Csyl4ik_3Xhj8LwMeta } from "/home/jetmix/histrf.ru/histrf-client/pages/index.vue?macro=true";
import { default as events5WXmd2Nlo55_2CP_AEl9p8oynj8lwCQNZQJBAKdMkJwMeta } from "/home/jetmix/histrf.ru/histrf-client/pages/events.vue?macro=true";
import { default as search3ediohTQE7DpW3I5JNqnIJxRFIqQV7h_45YQg9H5mJCfYMeta } from "/home/jetmix/histrf.ru/histrf-client/pages/search.vue?macro=true";
import { default as _summerqozbmIUvu1SZRX6PTfNFdNzFs18g4SA797QGce_45RniYMeta } from "/home/jetmix/histrf.ru/histrf-client/pages/_summer.vue?macro=true";
import { default as libraryi3SiYCV5eHVYw0IGK6XQYBGksjZcuaVa8HQaeyGPfTgMeta } from "/home/jetmix/histrf.ru/histrf-client/pages/library.vue?macro=true";
import { default as indexISprdWo_456a83oib3N9oGoG_1xlaBfiP8mwqqh7UM8j0Meta } from "/home/jetmix/histrf.ru/histrf-client/pages/teacher/index.vue?macro=true";
import { default as indexdXcaIC51fuZOFTypMSUyLLhzUCdpfhVQW0t12j0t_45oEMeta } from "/home/jetmix/histrf.ru/histrf-client/pages/teacher/[parent]/index.vue?macro=true";
import { default as indexayXnFXn8H7MQENx1IruE1XF7pmKe9bEBZozjVANCFCQMeta } from "/home/jetmix/histrf.ru/histrf-client/pages/teacher/[parent]/[category]/index.vue?macro=true";
import { default as _91chapter_93FlBBZ0YNeqfwkiIXH2mtAOp2ztlYJOs9tnUONxHWmjUMeta } from "/home/jetmix/histrf.ru/histrf-client/pages/teacher/[parent]/[category]/[chapter].vue?macro=true";
import { default as _91slug_93zlbGZVXaGncXPs8K4gJswufY0IdSK9QKK4ipOwY_BUMMeta } from "/home/jetmix/histrf.ru/histrf-client/pages/teacher/[parent]/[category]/book/[slug].vue?macro=true";
import { default as _91slug_93O7QT4a49aEMwrf8V1ZsV6JO9PUTDp2gycE_xDVYg25QMeta } from "/home/jetmix/histrf.ru/histrf-client/pages/teacher/[parent]/[category]/test/[slug].vue?macro=true";
import { default as _91slug_93SSgBdE5uWMK5IPW5HWXO1LaPm2r8jDeZOjsF2TLFNkQMeta } from "/home/jetmix/histrf.ru/histrf-client/pages/teacher/[parent]/[category]/article/[slug].vue?macro=true";
import { default as _91slug_93N7iyNpU7mXKH_45nRijhKsAaU58eXiGKWoinQfUmjvHEcMeta } from "/home/jetmix/histrf.ru/histrf-client/pages/teacher/[parent]/[category]/chapter/[slug].vue?macro=true";
import { default as _91slug_93yqu5x5X7puVTzbZVeYGYeq9QDi5652AufwBlzoIN8mMMeta } from "/home/jetmix/histrf.ru/histrf-client/pages/teacher/[parent]/[category]/audiolecture/[slug].vue?macro=true";
import { default as _91slug_93_45ZFlh6yIJmLxLJTUmjLMVYFPW1_45QsyqL6b2JvuGn3sUMeta } from "/home/jetmix/histrf.ru/histrf-client/pages/teacher/[parent]/[category]/videolecture/[slug].vue?macro=true";
import { default as _91category_93CczhMAkXw1qn7P47fmKn_45meyCmvPFKeyKAZHx5ZWh24Meta } from "/home/jetmix/histrf.ru/histrf-client/pages/teacher/[parent]/[category].vue?macro=true";
import { default as _91parent_93vgBg3o5CM_45_5ET49KRjlSPuKUKDL5U81U_4509NJaHFdkMeta } from "/home/jetmix/histrf.ru/histrf-client/pages/teacher/[parent].vue?macro=true";
import { default as _91slug_934wCvJaI41KM3EQlBS0bH68FFnCFjOUnu9VfAGvPFFn4Meta } from "/home/jetmix/histrf.ru/histrf-client/pages/teacher/glossary/[slug].vue?macro=true";
import { default as index6pO6E4Ts22h8oWAAtdWJZDnNi8vf7qy3ZQxmABeA7CIMeta } from "/home/jetmix/histrf.ru/histrf-client/pages/teacher/historical-calendar/index.vue?macro=true";
import { default as _91slug_93K4hwyNcHWnk3MjBtLuXyoCWo4P74rgEgoJD0I_45ekE_UMeta } from "/home/jetmix/histrf.ru/histrf-client/pages/teacher/historical-calendar/[slug].vue?macro=true";
import { default as teacherJOMB7Y8Et5qCmEn2nfKhTmOjDbUuAe8Uv_45H_q8SHasIMeta } from "/home/jetmix/histrf.ru/histrf-client/pages/teacher.vue?macro=true";
import { default as gpt_45chatKl_45WDq30CZMhbr_rlvGXrFay9fw9qG6Qv3d2kV_45XD5QMeta } from "/home/jetmix/histrf.ru/histrf-client/pages/gpt-chat.vue?macro=true";
import { default as myhistoryY4YKanM8qWRjUGTrt7dQaZH7V5UySgNsJZTP0c_RwKYMeta } from "/home/jetmix/histrf.ru/histrf-client/pages/myhistory.vue?macro=true";
import { default as indexlri0ftn5qAlExGjAYd8upXx91q8INo9Jjot3Um_454YzAMeta } from "/home/jetmix/histrf.ru/histrf-client/pages/about/index.vue?macro=true";
import { default as indexLnfCNFAjj2MhHkuRm4_eW0kwQhv7A12YDItGhWAO4CwMeta } from "/home/jetmix/histrf.ru/histrf-client/pages/destination/index.vue?macro=true";
import { default as indexNoo9TfEfWub1HpJxRxeWvryOvnHmXizZGQmPJXHyaSAMeta } from "/home/jetmix/histrf.ru/histrf-client/pages/destination/[paragraph]/index.vue?macro=true";
import { default as _91slug_93R0y_45iCw13cFHp5LkQa_452MyKflZJkJg67AWnOaeU_BW4Meta } from "/home/jetmix/histrf.ru/histrf-client/pages/destination/[paragraph]/region_route/[slug].vue?macro=true";
import { default as _91slug_93BE8vQ7qzIJaeHx7lG_45tAUvTAwr_45_45U0nnAI7I7jwcgWYMeta } from "/home/jetmix/histrf.ru/histrf-client/pages/destination/[paragraph]/region_article/[slug].vue?macro=true";
import { default as _91slug_93k3hFvDKgaLsgVnwTFF_S_453CBdEUag8W6Kl7dRqq8588Meta } from "/home/jetmix/histrf.ru/histrf-client/pages/destination/[paragraph]/region_heraldic/[slug].vue?macro=true";
import { default as _91paragraph_9389qxdxU3uh3Pnwu0zoeA3ttRvpyvIIxwn6nvvWtEhuYMeta } from "/home/jetmix/histrf.ru/histrf-client/pages/destination/[paragraph].vue?macro=true";
import { default as destinationbEyX1kvZhxxGX2f8TgJMiojj_45AvpHitPkcbiKEVFFa4Meta } from "/home/jetmix/histrf.ru/histrf-client/pages/destination.vue?macro=true";
import { default as index9dDS3SnxvM0OrIPT_45ct6JAzGKVUYhOWbWDV2tP_45FQNYMeta } from "/home/jetmix/histrf.ru/histrf-client/pages/games/index.vue?macro=true";
import { default as _91slug_93dRTOwDUX8o7xMhfpa_jfcieOs9Us8SMZrTPikLfEvqYMeta } from "/home/jetmix/histrf.ru/histrf-client/pages/tags/[slug].vue?macro=true";
import { default as indexieyGNfJIMazl0T8YDpcrh4ctLbspVuK0ysI1DhJ1BXIMeta } from "/home/jetmix/histrf.ru/histrf-client/pages/tests/index.vue?macro=true";
import { default as victory_45dayatsINi3mJj_45j5_oGoF4x33T0QiOkyH0qIiEpvDaHGGYMeta } from "/home/jetmix/histrf.ru/histrf-client/pages/victory-day.vue?macro=true";
import { default as _91slug_93vlfgwl4Y3QhSeI5WVfZ22fk0tq6tfxdcGR8LIP7qN0QMeta } from "/home/jetmix/histrf.ru/histrf-client/pages/games/[slug].vue?macro=true";
import { default as our_45partners6wJqXY7UngS1jjJOHQxAPKucNb8R3eEsrrLdq_45hyBTkMeta } from "/home/jetmix/histrf.ru/histrf-client/pages/our-partners.vue?macro=true";
import { default as _91slug_93fI8QLfRWm_LNoS_45xbdCaQQxt4zD6NkPRYCgkHB3_45PmYMeta } from "/home/jetmix/histrf.ru/histrf-client/pages/tests/[slug].vue?macro=true";
import { default as indexPGsSjFDJQG9C0I3c8k2fwulC_45JS_45R28TJGjaSVj1tDAMeta } from "/home/jetmix/histrf.ru/histrf-client/pages/authors/index.vue?macro=true";
import { default as indexJRvRzU9_3qiyoQftjiNISOcguvsbNvNi3u8QH6SDLKcMeta } from "/home/jetmix/histrf.ru/histrf-client/pages/profile/index.vue?macro=true";
import { default as _91slug_93ciGsI6rZcyU390RgFL0u28_yS1iCemp6Z9Njy3AjRMMMeta } from "/home/jetmix/histrf.ru/histrf-client/pages/authors/[slug].vue?macro=true";
import { default as privacy_policycajFH3_45lghmW9wA_451_45vFYfspfZVIThIwX5qfUOC4LxIMeta } from "/home/jetmix/histrf.ru/histrf-client/pages/privacy_policy.vue?macro=true";
import { default as index7yypYdoG4u9UsQIY18pndhVtz4R9XO56HZG281PMTU4Meta } from "/home/jetmix/histrf.ru/histrf-client/pages/projects/index.vue?macro=true";
import { default as indexB1JE6inPA_457HzXYk9k3ZtH_45DiuwZvxJBFo2N0SyZOcEMeta } from "/home/jetmix/histrf.ru/histrf-client/pages/timeline/index.vue?macro=true";
import { default as accounts6UYBNTkY_i33gH6egciPuVhJDwXR4mQ2faJMz2UauEMeta } from "/home/jetmix/histrf.ru/histrf-client/pages/profile/account.vue?macro=true";
import { default as results_XUd4E2_1PBMQOueK_45uAk_DRnW0czBCRg_i2G2Gzwc0Meta } from "/home/jetmix/histrf.ru/histrf-client/pages/profile/results.vue?macro=true";
import { default as indexyg6azF7I_45FkeDFUM5QIRi8gjeLVy4H84Egj7aMIV8lQMeta } from "/home/jetmix/histrf.ru/histrf-client/pages/read/news/index.vue?macro=true";
import { default as _91slug_930cO3ypOMPmR3opvVkwspXEkDZGZfadHjSzSCQxinsREMeta } from "/home/jetmix/histrf.ru/histrf-client/pages/read/news/[slug].vue?macro=true";
import { default as index_tYITTyTxOmY6B_45AFq4m3GngJk5vJ0MY5HfpG4_tjh4Meta } from "/home/jetmix/histrf.ru/histrf-client/pages/collections/index.vue?macro=true";
import { default as bookmarksFnewa3PbPnxmplzndmFoFHSvCiCbAu2F7z3UYa4OXaYMeta } from "/home/jetmix/histrf.ru/histrf-client/pages/profile/bookmarks.vue?macro=true";
import { default as indexnnkfMUdIzr_454FaPpV_1rlYEsDbeaiNPNw0sWmP2Ty1IMeta } from "/home/jetmix/histrf.ru/histrf-client/pages/watch/films/index.vue?macro=true";
import { default as _91slug_93r5meUylDfNgc1lDTJVFVpx2bR4porkSyy3YnvPclmIsMeta } from "/home/jetmix/histrf.ru/histrf-client/pages/collections/[slug].vue?macro=true";
import { default as indexhVyGKPgbSOf7WmYbvPHx8aUU7Hg9bZnYXK3_45YagO_roMeta } from "/home/jetmix/histrf.ru/histrf-client/pages/presentation/index.vue?macro=true";
import { default as indexEA1NBdaY2uhn4r0lYfYg3G14uzOF3ajHe0R1F3suoiQMeta } from "/home/jetmix/histrf.ru/histrf-client/pages/read/science/index.vue?macro=true";
import { default as _91slug_93o4YXWFJKlVMy4yV7yrw9PgNAz9XGeCCEKQkV45Te5ksMeta } from "/home/jetmix/histrf.ru/histrf-client/pages/watch/films/[slug].vue?macro=true";
import { default as indexsoBtu_3RDMyiIxFsAkLSCmZAkIvtsMwZ2CQAZmULHCsMeta } from "/home/jetmix/histrf.ru/histrf-client/pages/read/articles/index.vue?macro=true";
import { default as _91slug_93RTDQ8D2r1pB_NjfTEwhzUHgSc2iKV3C7CFL4sY7WEssMeta } from "/home/jetmix/histrf.ru/histrf-client/pages/read/science/[slug].vue?macro=true";
import { default as indexB1hTZellXJDJAJWwQjtD4_DchnP_45g4fu_4546Z7sdCFEQMeta } from "/home/jetmix/histrf.ru/histrf-client/pages/watch/courses/index.vue?macro=true";
import { default as indexDzGUVEfrN3ItiW3WIbDCNxkgrdN3YINa_ZUSTfbT3lwMeta } from "/home/jetmix/histrf.ru/histrf-client/pages/listen/courses/index.vue?macro=true";
import { default as _91slug_93Z1zXvKfOjOIrE6jRVc2P_ay0TNLWIPRe_452P_EI_45JkIQMeta } from "/home/jetmix/histrf.ru/histrf-client/pages/read/articles/[slug].vue?macro=true";
import { default as index67vCCxpNDPs_o3Od2AqhOgBvQfLwpO8__45aPAVxFZkfYMeta } from "/home/jetmix/histrf.ru/histrf-client/pages/read/documents/index.vue?macro=true";
import { default as index2UeTU4_45dZmHKyUcTgR3wWljyoHPN9vmu9hbTx1vqvNUMeta } from "/home/jetmix/histrf.ru/histrf-client/pages/read/monuments/index.vue?macro=true";
import { default as _91slug_93q67ORGsQNj1YvfznzLwB3tkhbDGo_452cjJjVUqo5xi2cMeta } from "/home/jetmix/histrf.ru/histrf-client/pages/watch/courses/[slug].vue?macro=true";
import { default as indexS7flJJ6Ti_45iTGZ7RJhceSH8eF4mBPKGFpnO4DXI_45S_oMeta } from "/home/jetmix/histrf.ru/histrf-client/pages/watch/lectures/index.vue?macro=true";
import { default as indexk8N_tQwX58XtrucAkAbR46G78lNBdH4KLZNqqg86LU8Meta } from "/home/jetmix/histrf.ru/histrf-client/pages/watch/memdates/index.vue?macro=true";
import { default as indexdgpZhUgJJ8g9NoVUfDvusm9pASxkCFo7GCDfgDQ2wHsMeta } from "/home/jetmix/histrf.ru/histrf-client/pages/historical-maps/index.vue?macro=true";
import { default as _91slug_93vqFxXhQERVMWBs_ll8hu_QaznQdiKcJl0aEfIVRSgLQMeta } from "/home/jetmix/histrf.ru/histrf-client/pages/listen/courses/[slug].vue?macro=true";
import { default as indexPsq02P_45IIL3kWj006T111H6hnOzgbWNQIxQIetudzq0Meta } from "/home/jetmix/histrf.ru/histrf-client/pages/listen/lectures/index.vue?macro=true";
import { default as _91slug_93QqaQS7tcb_45w5p_3EIqXTD0f57j5123UC2xz3DLy08WsMeta } from "/home/jetmix/histrf.ru/histrf-client/pages/read/monuments/[slug].vue?macro=true";
import { default as _91slug_932sXajSbPauSeYh5AABPQCOxzfH_45UGVWNHMk7JtkPTooMeta } from "/home/jetmix/histrf.ru/histrf-client/pages/watch/lectures/[slug].vue?macro=true";
import { default as _91slug_93Yuo0up00BRS4Hkuic_45rxDtKEU7hrbPyJp0yYm9R8QtkMeta } from "/home/jetmix/histrf.ru/histrf-client/pages/historical-maps/[slug].vue?macro=true";
import { default as _91slug_93Si0DNSS59iA46p_Xx9uY_Bgrvby74Ac9FfkvQqe_GygMeta } from "/home/jetmix/histrf.ru/histrf-client/pages/listen/lectures/[slug].vue?macro=true";
import { default as index3D3G7bPclYPsq1YS0HXY8JdBviH7X4v9FmIfD8miroYMeta } from "/home/jetmix/histrf.ru/histrf-client/pages/read/biographies/index.vue?macro=true";
import { default as _91slug_93uyp_45_or9Q8A0qkb2XjaUQU8deBZAIUCzOWs1wVvz5hsMeta } from "/home/jetmix/histrf.ru/histrf-client/pages/magazine/article/[slug].vue?macro=true";
import { default as _91slug_93Ghesq74QInuX5rFSpsZfs9owQF6j_4592WqliT5_x_zNgMeta } from "/home/jetmix/histrf.ru/histrf-client/pages/magazine/release/[slug].vue?macro=true";
import { default as _91slug_93OSTf9FIc04qw58NeJdqsGgIIQ_45xHr24kJQJOR9rBpgsMeta } from "/home/jetmix/histrf.ru/histrf-client/pages/read/biographies/[slug].vue?macro=true";
import { default as indexbgtMjwfphCJNwDYznLrGOGtF_Daemfg6HM_458FQW4wNAMeta } from "/home/jetmix/histrf.ru/histrf-client/pages/watch/unknown-war/index.vue?macro=true";
import { default as _91slug_93f1kUG8bMW3rC_bONUs7sRmLwsST1xltLd68VroRSot4Meta } from "/home/jetmix/histrf.ru/histrf-client/pages/watch/unknown-war/[slug].vue?macro=true";
import { default as privacy_policy_application_tr0tqPmqBheomZs5nddEL2C0bZkB_2_7lg88KCOFlgMeta } from "/home/jetmix/histrf.ru/histrf-client/pages/privacy_policy_application.vue?macro=true";
import { default as indexBHyTPA6nQWZooJEOPekvWQVrBV6QhzogcpN_keP1SUgMeta } from "/home/jetmix/histrf.ru/histrf-client/pages/watch/videomaterials/index.vue?macro=true";
import { default as index8rsC9WL3KPLiNLYpAgEG63tWNcw9Af5GcJwd6YhupEkMeta } from "/home/jetmix/histrf.ru/histrf-client/pages/read/documents/[slug]/index.vue?macro=true";
import { default as indexfYbf0xINT0_45lov4JQpQexZ9bIrf_451VpcuvBL27NuHfIMeta } from "/home/jetmix/histrf.ru/histrf-client/pages/watch/people-of-history/index.vue?macro=true";
import { default as _91slug_932pbM80_457bZu_ROPDKv3aybbRiVcmi1dCKe1kkcTt96IMeta } from "/home/jetmix/histrf.ru/histrf-client/pages/watch/people-of-history/[slug].vue?macro=true";
import { default as _91document_93LBIoWC75_45Bhp8WSLtULSLcgBUZVGAlJp1uiHPwWBRO0Meta } from "/home/jetmix/histrf.ru/histrf-client/pages/read/documents/[slug]/[document].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: indexC4wtTfMSq5wSxagLwVnpzz9qSv14Csyl4ik_3Xhj8LwMeta || {},
    component: () => import("/home/jetmix/histrf.ru/histrf-client/pages/index.vue")
  },
  {
    name: "events",
    path: "/events",
    component: () => import("/home/jetmix/histrf.ru/histrf-client/pages/events.vue")
  },
  {
    name: "search",
    path: "/search",
    meta: search3ediohTQE7DpW3I5JNqnIJxRFIqQV7h_45YQg9H5mJCfYMeta || {},
    component: () => import("/home/jetmix/histrf.ru/histrf-client/pages/search.vue")
  },
  {
    name: "_summer",
    path: "/_summer",
    component: () => import("/home/jetmix/histrf.ru/histrf-client/pages/_summer.vue")
  },
  {
    name: "library",
    path: "/library",
    component: () => import("/home/jetmix/histrf.ru/histrf-client/pages/library.vue")
  },
  {
    name: teacherJOMB7Y8Et5qCmEn2nfKhTmOjDbUuAe8Uv_45H_q8SHasIMeta?.name,
    path: "/teacher",
    component: () => import("/home/jetmix/histrf.ru/histrf-client/pages/teacher.vue"),
    children: [
  {
    name: "teacher",
    path: "",
    component: () => import("/home/jetmix/histrf.ru/histrf-client/pages/teacher/index.vue")
  },
  {
    name: _91parent_93vgBg3o5CM_45_5ET49KRjlSPuKUKDL5U81U_4509NJaHFdkMeta?.name,
    path: ":parent()",
    component: () => import("/home/jetmix/histrf.ru/histrf-client/pages/teacher/[parent].vue"),
    children: [
  {
    name: "teacher-parent",
    path: "",
    meta: indexdXcaIC51fuZOFTypMSUyLLhzUCdpfhVQW0t12j0t_45oEMeta || {},
    component: () => import("/home/jetmix/histrf.ru/histrf-client/pages/teacher/[parent]/index.vue")
  },
  {
    name: _91category_93CczhMAkXw1qn7P47fmKn_45meyCmvPFKeyKAZHx5ZWh24Meta?.name,
    path: ":category()",
    component: () => import("/home/jetmix/histrf.ru/histrf-client/pages/teacher/[parent]/[category].vue"),
    children: [
  {
    name: "teacher-parent-category",
    path: "",
    meta: indexayXnFXn8H7MQENx1IruE1XF7pmKe9bEBZozjVANCFCQMeta || {},
    component: () => import("/home/jetmix/histrf.ru/histrf-client/pages/teacher/[parent]/[category]/index.vue")
  },
  {
    name: "teacher-parent-category-chapter",
    path: ":chapter()",
    component: () => import("/home/jetmix/histrf.ru/histrf-client/pages/teacher/[parent]/[category]/[chapter].vue")
  },
  {
    name: "teacher-parent-category-book-slug",
    path: "book/:slug()",
    meta: _91slug_93zlbGZVXaGncXPs8K4gJswufY0IdSK9QKK4ipOwY_BUMMeta || {},
    component: () => import("/home/jetmix/histrf.ru/histrf-client/pages/teacher/[parent]/[category]/book/[slug].vue")
  },
  {
    name: "teacher-parent-category-test-slug",
    path: "test/:slug()",
    meta: _91slug_93O7QT4a49aEMwrf8V1ZsV6JO9PUTDp2gycE_xDVYg25QMeta || {},
    component: () => import("/home/jetmix/histrf.ru/histrf-client/pages/teacher/[parent]/[category]/test/[slug].vue")
  },
  {
    name: "teacher-parent-category-article-slug",
    path: "article/:slug()",
    meta: _91slug_93SSgBdE5uWMK5IPW5HWXO1LaPm2r8jDeZOjsF2TLFNkQMeta || {},
    component: () => import("/home/jetmix/histrf.ru/histrf-client/pages/teacher/[parent]/[category]/article/[slug].vue")
  },
  {
    name: "teacher-parent-category-chapter-slug",
    path: "chapter/:slug()",
    component: () => import("/home/jetmix/histrf.ru/histrf-client/pages/teacher/[parent]/[category]/chapter/[slug].vue")
  },
  {
    name: "teacher-parent-category-audiolecture-slug",
    path: "audiolecture/:slug()",
    meta: _91slug_93yqu5x5X7puVTzbZVeYGYeq9QDi5652AufwBlzoIN8mMMeta || {},
    component: () => import("/home/jetmix/histrf.ru/histrf-client/pages/teacher/[parent]/[category]/audiolecture/[slug].vue")
  },
  {
    name: "teacher-parent-category-videolecture-slug",
    path: "videolecture/:slug()",
    meta: _91slug_93_45ZFlh6yIJmLxLJTUmjLMVYFPW1_45QsyqL6b2JvuGn3sUMeta || {},
    component: () => import("/home/jetmix/histrf.ru/histrf-client/pages/teacher/[parent]/[category]/videolecture/[slug].vue")
  }
]
  }
]
  },
  {
    name: "teacher-glossary-slug",
    path: "glossary/:slug()",
    component: () => import("/home/jetmix/histrf.ru/histrf-client/pages/teacher/glossary/[slug].vue")
  },
  {
    name: "teacher-historical-calendar",
    path: "historical-calendar",
    component: () => import("/home/jetmix/histrf.ru/histrf-client/pages/teacher/historical-calendar/index.vue")
  },
  {
    name: "teacher-historical-calendar-slug",
    path: "historical-calendar/:slug()",
    meta: _91slug_93K4hwyNcHWnk3MjBtLuXyoCWo4P74rgEgoJD0I_45ekE_UMeta || {},
    component: () => import("/home/jetmix/histrf.ru/histrf-client/pages/teacher/historical-calendar/[slug].vue")
  }
]
  },
  {
    name: "gpt-chat",
    path: "/gpt-chat",
    component: () => import("/home/jetmix/histrf.ru/histrf-client/pages/gpt-chat.vue")
  },
  {
    name: "myhistory",
    path: "/myhistory",
    component: () => import("/home/jetmix/histrf.ru/histrf-client/pages/myhistory.vue")
  },
  {
    name: "about",
    path: "/about",
    component: () => import("/home/jetmix/histrf.ru/histrf-client/pages/about/index.vue")
  },
  {
    name: destinationbEyX1kvZhxxGX2f8TgJMiojj_45AvpHitPkcbiKEVFFa4Meta?.name,
    path: "/destination",
    component: () => import("/home/jetmix/histrf.ru/histrf-client/pages/destination.vue"),
    children: [
  {
    name: "destination",
    path: "",
    component: () => import("/home/jetmix/histrf.ru/histrf-client/pages/destination/index.vue")
  },
  {
    name: _91paragraph_9389qxdxU3uh3Pnwu0zoeA3ttRvpyvIIxwn6nvvWtEhuYMeta?.name,
    path: ":paragraph()",
    component: () => import("/home/jetmix/histrf.ru/histrf-client/pages/destination/[paragraph].vue"),
    children: [
  {
    name: "destination-paragraph",
    path: "",
    component: () => import("/home/jetmix/histrf.ru/histrf-client/pages/destination/[paragraph]/index.vue")
  },
  {
    name: "destination-paragraph-region_route-slug",
    path: "region_route/:slug()",
    meta: _91slug_93R0y_45iCw13cFHp5LkQa_452MyKflZJkJg67AWnOaeU_BW4Meta || {},
    component: () => import("/home/jetmix/histrf.ru/histrf-client/pages/destination/[paragraph]/region_route/[slug].vue")
  },
  {
    name: "destination-paragraph-region_article-slug",
    path: "region_article/:slug()",
    meta: _91slug_93BE8vQ7qzIJaeHx7lG_45tAUvTAwr_45_45U0nnAI7I7jwcgWYMeta || {},
    component: () => import("/home/jetmix/histrf.ru/histrf-client/pages/destination/[paragraph]/region_article/[slug].vue")
  },
  {
    name: "destination-paragraph-region_heraldic-slug",
    path: "region_heraldic/:slug()",
    meta: _91slug_93k3hFvDKgaLsgVnwTFF_S_453CBdEUag8W6Kl7dRqq8588Meta || {},
    component: () => import("/home/jetmix/histrf.ru/histrf-client/pages/destination/[paragraph]/region_heraldic/[slug].vue")
  }
]
  }
]
  },
  {
    name: "games",
    path: "/games",
    component: () => import("/home/jetmix/histrf.ru/histrf-client/pages/games/index.vue")
  },
  {
    name: "tags-slug",
    path: "/tags/:slug()",
    component: () => import("/home/jetmix/histrf.ru/histrf-client/pages/tags/[slug].vue")
  },
  {
    name: "tests",
    path: "/tests",
    component: () => import("/home/jetmix/histrf.ru/histrf-client/pages/tests/index.vue")
  },
  {
    name: "victory-day",
    path: "/victory-day",
    component: () => import("/home/jetmix/histrf.ru/histrf-client/pages/victory-day.vue")
  },
  {
    name: "games-slug",
    path: "/games/:slug()",
    meta: _91slug_93vlfgwl4Y3QhSeI5WVfZ22fk0tq6tfxdcGR8LIP7qN0QMeta || {},
    component: () => import("/home/jetmix/histrf.ru/histrf-client/pages/games/[slug].vue")
  },
  {
    name: "our-partners",
    path: "/our-partners",
    component: () => import("/home/jetmix/histrf.ru/histrf-client/pages/our-partners.vue")
  },
  {
    name: "tests-slug",
    path: "/tests/:slug()",
    meta: { ...(_91slug_93fI8QLfRWm_LNoS_45xbdCaQQxt4zD6NkPRYCgkHB3_45PmYMeta || {}), ...{"middleware":["test-check"]} },
    component: () => import("/home/jetmix/histrf.ru/histrf-client/pages/tests/[slug].vue")
  },
  {
    name: "authors",
    path: "/authors",
    component: () => import("/home/jetmix/histrf.ru/histrf-client/pages/authors/index.vue")
  },
  {
    name: "profile",
    path: "/profile",
    meta: indexJRvRzU9_3qiyoQftjiNISOcguvsbNvNi3u8QH6SDLKcMeta || {},
    component: () => import("/home/jetmix/histrf.ru/histrf-client/pages/profile/index.vue")
  },
  {
    name: "authors-slug",
    path: "/authors/:slug()",
    component: () => import("/home/jetmix/histrf.ru/histrf-client/pages/authors/[slug].vue")
  },
  {
    name: "privacy_policy",
    path: "/privacy_policy",
    component: () => import("/home/jetmix/histrf.ru/histrf-client/pages/privacy_policy.vue")
  },
  {
    name: "projects",
    path: "/projects",
    component: () => import("/home/jetmix/histrf.ru/histrf-client/pages/projects/index.vue")
  },
  {
    name: "timeline",
    path: "/timeline",
    component: () => import("/home/jetmix/histrf.ru/histrf-client/pages/timeline/index.vue")
  },
  {
    name: "profile-account",
    path: "/profile/account",
    meta: accounts6UYBNTkY_i33gH6egciPuVhJDwXR4mQ2faJMz2UauEMeta || {},
    component: () => import("/home/jetmix/histrf.ru/histrf-client/pages/profile/account.vue")
  },
  {
    name: "profile-results",
    path: "/profile/results",
    meta: results_XUd4E2_1PBMQOueK_45uAk_DRnW0czBCRg_i2G2Gzwc0Meta || {},
    component: () => import("/home/jetmix/histrf.ru/histrf-client/pages/profile/results.vue")
  },
  {
    name: "read-news",
    path: "/read/news",
    component: () => import("/home/jetmix/histrf.ru/histrf-client/pages/read/news/index.vue")
  },
  {
    name: "read-news-slug",
    path: "/read/news/:slug()",
    meta: _91slug_930cO3ypOMPmR3opvVkwspXEkDZGZfadHjSzSCQxinsREMeta || {},
    component: () => import("/home/jetmix/histrf.ru/histrf-client/pages/read/news/[slug].vue")
  },
  {
    name: "collections",
    path: "/collections",
    component: () => import("/home/jetmix/histrf.ru/histrf-client/pages/collections/index.vue")
  },
  {
    name: "profile-bookmarks",
    path: "/profile/bookmarks",
    meta: bookmarksFnewa3PbPnxmplzndmFoFHSvCiCbAu2F7z3UYa4OXaYMeta || {},
    component: () => import("/home/jetmix/histrf.ru/histrf-client/pages/profile/bookmarks.vue")
  },
  {
    name: "watch-films",
    path: "/watch/films",
    component: () => import("/home/jetmix/histrf.ru/histrf-client/pages/watch/films/index.vue")
  },
  {
    name: "collections-slug",
    path: "/collections/:slug()",
    meta: _91slug_93r5meUylDfNgc1lDTJVFVpx2bR4porkSyy3YnvPclmIsMeta || {},
    component: () => import("/home/jetmix/histrf.ru/histrf-client/pages/collections/[slug].vue")
  },
  {
    name: "presentation",
    path: "/presentation",
    component: () => import("/home/jetmix/histrf.ru/histrf-client/pages/presentation/index.vue")
  },
  {
    name: "read-science",
    path: "/read/science",
    component: () => import("/home/jetmix/histrf.ru/histrf-client/pages/read/science/index.vue")
  },
  {
    name: "watch-films-slug",
    path: "/watch/films/:slug()",
    meta: _91slug_93o4YXWFJKlVMy4yV7yrw9PgNAz9XGeCCEKQkV45Te5ksMeta || {},
    component: () => import("/home/jetmix/histrf.ru/histrf-client/pages/watch/films/[slug].vue")
  },
  {
    name: "read-articles",
    path: "/read/articles",
    component: () => import("/home/jetmix/histrf.ru/histrf-client/pages/read/articles/index.vue")
  },
  {
    name: "read-science-slug",
    path: "/read/science/:slug()",
    meta: _91slug_93RTDQ8D2r1pB_NjfTEwhzUHgSc2iKV3C7CFL4sY7WEssMeta || {},
    component: () => import("/home/jetmix/histrf.ru/histrf-client/pages/read/science/[slug].vue")
  },
  {
    name: "watch-courses",
    path: "/watch/courses",
    component: () => import("/home/jetmix/histrf.ru/histrf-client/pages/watch/courses/index.vue")
  },
  {
    name: "listen-courses",
    path: "/listen/courses",
    component: () => import("/home/jetmix/histrf.ru/histrf-client/pages/listen/courses/index.vue")
  },
  {
    name: "read-articles-slug",
    path: "/read/articles/:slug()",
    meta: _91slug_93Z1zXvKfOjOIrE6jRVc2P_ay0TNLWIPRe_452P_EI_45JkIQMeta || {},
    component: () => import("/home/jetmix/histrf.ru/histrf-client/pages/read/articles/[slug].vue")
  },
  {
    name: "read-documents",
    path: "/read/documents",
    component: () => import("/home/jetmix/histrf.ru/histrf-client/pages/read/documents/index.vue")
  },
  {
    name: "read-monuments",
    path: "/read/monuments",
    component: () => import("/home/jetmix/histrf.ru/histrf-client/pages/read/monuments/index.vue")
  },
  {
    name: "watch-courses-slug",
    path: "/watch/courses/:slug()",
    meta: _91slug_93q67ORGsQNj1YvfznzLwB3tkhbDGo_452cjJjVUqo5xi2cMeta || {},
    component: () => import("/home/jetmix/histrf.ru/histrf-client/pages/watch/courses/[slug].vue")
  },
  {
    name: "watch-lectures",
    path: "/watch/lectures",
    component: () => import("/home/jetmix/histrf.ru/histrf-client/pages/watch/lectures/index.vue")
  },
  {
    name: "watch-memdates",
    path: "/watch/memdates",
    component: () => import("/home/jetmix/histrf.ru/histrf-client/pages/watch/memdates/index.vue")
  },
  {
    name: "historical-maps",
    path: "/historical-maps",
    component: () => import("/home/jetmix/histrf.ru/histrf-client/pages/historical-maps/index.vue")
  },
  {
    name: "listen-courses-slug",
    path: "/listen/courses/:slug()",
    meta: _91slug_93vqFxXhQERVMWBs_ll8hu_QaznQdiKcJl0aEfIVRSgLQMeta || {},
    component: () => import("/home/jetmix/histrf.ru/histrf-client/pages/listen/courses/[slug].vue")
  },
  {
    name: "listen-lectures",
    path: "/listen/lectures",
    component: () => import("/home/jetmix/histrf.ru/histrf-client/pages/listen/lectures/index.vue")
  },
  {
    name: "read-monuments-slug",
    path: "/read/monuments/:slug()",
    meta: _91slug_93QqaQS7tcb_45w5p_3EIqXTD0f57j5123UC2xz3DLy08WsMeta || {},
    component: () => import("/home/jetmix/histrf.ru/histrf-client/pages/read/monuments/[slug].vue")
  },
  {
    name: "watch-lectures-slug",
    path: "/watch/lectures/:slug()",
    meta: _91slug_932sXajSbPauSeYh5AABPQCOxzfH_45UGVWNHMk7JtkPTooMeta || {},
    component: () => import("/home/jetmix/histrf.ru/histrf-client/pages/watch/lectures/[slug].vue")
  },
  {
    name: "historical-maps-slug",
    path: "/historical-maps/:slug()",
    meta: _91slug_93Yuo0up00BRS4Hkuic_45rxDtKEU7hrbPyJp0yYm9R8QtkMeta || {},
    component: () => import("/home/jetmix/histrf.ru/histrf-client/pages/historical-maps/[slug].vue")
  },
  {
    name: "listen-lectures-slug",
    path: "/listen/lectures/:slug()",
    component: () => import("/home/jetmix/histrf.ru/histrf-client/pages/listen/lectures/[slug].vue")
  },
  {
    name: "read-biographies",
    path: "/read/biographies",
    component: () => import("/home/jetmix/histrf.ru/histrf-client/pages/read/biographies/index.vue")
  },
  {
    name: "magazine-article-slug",
    path: "/magazine/article/:slug()",
    component: () => import("/home/jetmix/histrf.ru/histrf-client/pages/magazine/article/[slug].vue")
  },
  {
    name: "magazine-release-slug",
    path: "/magazine/release/:slug()",
    component: () => import("/home/jetmix/histrf.ru/histrf-client/pages/magazine/release/[slug].vue")
  },
  {
    name: "read-biographies-slug",
    path: "/read/biographies/:slug()",
    meta: _91slug_93OSTf9FIc04qw58NeJdqsGgIIQ_45xHr24kJQJOR9rBpgsMeta || {},
    component: () => import("/home/jetmix/histrf.ru/histrf-client/pages/read/biographies/[slug].vue")
  },
  {
    name: "watch-unknown-war",
    path: "/watch/unknown-war",
    component: () => import("/home/jetmix/histrf.ru/histrf-client/pages/watch/unknown-war/index.vue")
  },
  {
    name: "watch-unknown-war-slug",
    path: "/watch/unknown-war/:slug()",
    meta: _91slug_93f1kUG8bMW3rC_bONUs7sRmLwsST1xltLd68VroRSot4Meta || {},
    component: () => import("/home/jetmix/histrf.ru/histrf-client/pages/watch/unknown-war/[slug].vue")
  },
  {
    name: "privacy_policy_application",
    path: "/privacy_policy_application",
    component: () => import("/home/jetmix/histrf.ru/histrf-client/pages/privacy_policy_application.vue")
  },
  {
    name: "watch-videomaterials",
    path: "/watch/videomaterials",
    component: () => import("/home/jetmix/histrf.ru/histrf-client/pages/watch/videomaterials/index.vue")
  },
  {
    name: "read-documents-slug",
    path: "/read/documents/:slug()",
    component: () => import("/home/jetmix/histrf.ru/histrf-client/pages/read/documents/[slug]/index.vue")
  },
  {
    name: "watch-people-of-history",
    path: "/watch/people-of-history",
    component: () => import("/home/jetmix/histrf.ru/histrf-client/pages/watch/people-of-history/index.vue")
  },
  {
    name: "watch-people-of-history-slug",
    path: "/watch/people-of-history/:slug()",
    meta: _91slug_932pbM80_457bZu_ROPDKv3aybbRiVcmi1dCKe1kkcTt96IMeta || {},
    component: () => import("/home/jetmix/histrf.ru/histrf-client/pages/watch/people-of-history/[slug].vue")
  },
  {
    name: "read-documents-slug-document",
    path: "/read/documents/:slug()/:document()",
    meta: _91document_93LBIoWC75_45Bhp8WSLtULSLcgBUZVGAlJp1uiHPwWBRO0Meta || {},
    component: () => import("/home/jetmix/histrf.ru/histrf-client/pages/read/documents/[slug]/[document].vue")
  }
]